import { StyleFunctionProps, theme } from '@chakra-ui/react';

export default {
  baseStyle: {
    ...theme.components.Table.baseStyle,
    tbody: {
      tr: {
        td: {
          fontVariantNumeric: 'normal',
        },
        th: {
          fontVariantNumeric: 'normal',
        },
      },
    },
  },
  variants: {
    striped: (props: StyleFunctionProps) =>
      props.colorScheme === 'lightgray'
        ? {
            tbody: {
              tr: {
                '&:nth-of-type(odd)': {
                  td: {
                    background: '#F7F7F7',
                    borderBottomWidth: '0px',
                  },
                },
                'td th': {
                  borderBottomWidth: '0px',
                },
              },
            },
          }
        : {},
  },
};
